import * as cart from '@shopify/theme-cart';

export default function init ({ el, context }) {

  const getCartState = async () => {
    await cart.getState()
  }

  el.addEventListener('submit', async (event) => {
    debugger
    event.preventDefault();
    cartData = await getCartState;
    let hasSubscription = false
    for (var i = cartData.items.length - 1; i >= 0; i--) {
      if(cartData.items[i].properties.hasProperty('_is_subscription')){
        hasSubscription = true
        break
      }
    }
    window.location.href = "/checkout"
  })

}